// src/components/ErrorDisplay.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorDisplayProps {
  message: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
      <strong className="font-bold">{t('errors.error')}!</strong>
      <span className="block sm:inline"> {message}</span>
    </div>
  );
};

export default ErrorDisplay;